import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import type { Sprint } from "@/services/sprint.service";
import { STATUS_BADGE, formatSprintRange } from "./sprint-utils";
import { SprintActions, type SprintRowHandlers } from "./SprintActions";

export function SprintsList({ sprints, ...handlers }: SprintRowHandlers & { sprints: Sprint[] }) {
	const navigate = useNavigate();

	return (
		<div className="space-y-3">
			{sprints.map((sprint) => {
				const { variant, label } = STATUS_BADGE[sprint.status];
				return (
					<Card
						key={sprint.id}
						className="flex flex-col gap-3 px-5 py-4 sm:flex-row sm:items-center sm:gap-4"
					>
						<button
							type="button"
							onClick={() => navigate(`/sprints/${sprint.id}`)}
							className="min-w-0 flex-1 text-left group cursor-pointer"
						>
							<p className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors">
								{sprint.name}
							</p>
							<p className="text-xs text-muted mt-0.5">
								{formatSprintRange(sprint.start_date, sprint.end_date)}
							</p>
						</button>

						<div className="flex items-center justify-between gap-3 sm:contents">
							<Badge variant={variant} className="shrink-0">{label}</Badge>
							<SprintActions sprint={sprint} {...handlers} />
						</div>
					</Card>
				);
			})}
		</div>
	);
}
